import StartupsCaptablesInstance from 'modules/startupsCaptables/repository';

export const getCaptableShare = (id, share) => StartupsCaptablesInstance.getStartupCaptableShare(id, share);

export const getCaptableDebt = (id, debt) => StartupsCaptablesInstance.getStartupCaptableDebt(id, debt);

export const getCaptableOption = (id, option) => StartupsCaptablesInstance.getStartupCaptableOption(id, option);

export const postCaptableWaterfalls = (id, data) => StartupsCaptablesInstance.postStartupCaptableWaterfalls(id, data);

export const getCaptableWaterfall = (id, waterfall, params = {}) => StartupsCaptablesInstance.getStartupCaptableWaterfall(id, waterfall, params);

export const putCaptableWaterfall = (id, waterfall, data) => StartupsCaptablesInstance.putStartupCaptableWaterfalls(id, waterfall, data);

export const deleteCaptableWaterfall = (id, waterfall) => StartupsCaptablesInstance.deleteStartupCaptableWaterfalls(id, waterfall);
